import { Resources, useResource } from "Infrastructure/Translation/Resources";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
} from "@mui/material";

const resource = Resources.base.order.editForm;

type Props = {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
	isPending: boolean;
};

export function UpdateZoneDialog({
	open,
	onClose,
	onConfirm,
	isPending,
}: Props) {
	const { t } = useResource();

	return (
		<Dialog open={open} onClose={onClose}>
			<DialogTitle>{t(resource.zoneUpdateTitle)}</DialogTitle>
			<DialogContent>{t(resource.zoneUpdateMessage)}</DialogContent>
			<DialogActions>
				<Button variant="outlined" onClick={onClose}>
					{t(resource.zoneUpdateCancel)}
				</Button>
				<Button variant="contained" onClick={onConfirm} loading={isPending}>
					{t(resource.zoneUpdateConfirm)}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
